import { NSFunctions } from './functions';

export let NSDateDatetime = {};

NSDateDatetime.init = function()
{
    NSDateDatetimePrivate.init();
	
    this.NSDate = {};

    this.NSDate.f_create_elem_date =                            function () { return NSDateDatetimePrivate.NSDate.f_create_elem_date.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	this.NSDate.f_set_elem_value_from_db_date_string =          function () { return NSDateDatetimePrivate.NSDate.f_set_elem_value_from_db_date_string.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	
    this.NSDate.f_create_elem_date =                            function () { return NSDateDatetimePrivate.NSDate.f_create_elem_date.apply( NSDateDatetimePrivate.NSDate, arguments ); };
    this.NSDate.f_get_value =                                   function () { return NSDateDatetimePrivate.NSDate.f_get_value.apply( NSDateDatetimePrivate.NSDate, arguments ); };
    this.NSDate.f_date_is_valid =                               function () { return NSDateDatetimePrivate.NSDate.f_date_is_valid.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	
	this.NSDate.f_get_value_as_db_date_string =					function () { return NSDateDatetimePrivate.NSDate.f_get_value_as_db_date_string.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	this.NSDate.f_get_fe_s_value_as_db_date_string =			function () { return NSDateDatetimePrivate.NSDate.f_get_fe_s_value_as_db_date_string.apply( NSDateDatetimePrivate.NSDate, arguments ); };

	this.NSDate.f_convert_from__db_format__to__update_format = 	function () { return NSDateDatetimePrivate.NSDate.f_convert_from__db_format__to__update_format.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	
	this.NSDate.f_get_value_as_fe_presentation_date_string = 			function () { return NSDateDatetimePrivate.NSDate.f_get_value_as_fe_presentation_date_string.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	this.NSDate.f_get_value_as_fe_presentation_date_string_vers_02 = 	function () { return NSDateDatetimePrivate.NSDate.f_get_value_as_fe_presentation_date_string_vers_02.apply( NSDateDatetimePrivate.NSDate, arguments ); };
	 	
    
	window.NSDateDatetime_ = NSDateDatetime;
	window.NSDateDatetimePrivate_ = NSDateDatetimePrivate;

	
}

let NSDateDatetimePrivate = 
{

    init: function()
    {

    },

	NSDate: {
		
		
		
		f_create_elem_date: function ()
		{
			var e_ = document.createElement("input");
			//e_.setAttribute("id", s_id);
			e_.setAttribute("type", "date");
			e_.setAttribute("placeholder", "");
				
	
			var b_type_date_is_supported = this.f_check_input_type_date_support();
			if(!b_type_date_is_supported)
			{
				e_.setAttribute("placeholder", "yyyy-mm-dd");
			}
			
			return e_;	
			
			
		},
		
		f_get_value: function(e_input)
		{
			return e_input.value;
		},
		
		//s_value -> "yyyy-mm-dd"
		f_set_value: function(e_input, s_value)
		{
			return e_input.value = s_value;
		},
		/*
		s_value -> "month day, year" ex: "Apr 9, 2010"
		*/
		f_set_elem_value_from_db_date_string: function(e_input, s_value)
		{
			
			var s_value_processed_ = this.f_get_value_from_date_db_string(s_value);

			/*
			//removing 'Z' at the end
			s_value_processed_ = (s_value_processed_!=null && s_value_processed_.length>0) ? 
										s_value_processed_.substr(0, s_value_processed_.length-1) :
										s_value_processed_;
			*/
			
			this.f_set_value(e_input, s_value_processed_);
			
		},
		/*
		s_value 	-> "month day, year" ex: "Apr 9, 2010"
		s_value_out	-> "yyyy-mm-dd"
		*/
		f_get_value_from_date_db_string: function(s_value)
		{
			var s_value_out;
			
			if(s_value !=null && s_value != "")
			{
				var a_date = new Date( s_value );
				
				var a_year =  a_date.getFullYear();
				var a_month = a_date.getMonth()  +1;
				var a_day = a_date.getDate();
				
				if( a_date  && a_year &&  a_month  && a_day ){
					a_year =  this.f_add_left_zeros( 4 , a_date.getFullYear().toString() );
					a_month =  this.f_add_left_zeros( 2 , (a_date.getMonth() + 1).toString() );
					a_date = this.f_add_left_zeros( 2 , a_date.getDate().toString() );
				
					//s_value_out = a_year + "-" + a_month  + "-" + a_date;
					return s_value;
				}
				else
				{
					s_value_out = "";
				}
				
			}
			else
			{
				s_value_out = "";
			}
			
			return s_value_out;
		},
		
		/*
			s_value_out -> "month day, year" ex: "Apr 9, 2010"
		*/
		f_get_value_as_db_date_string: function(e_input)
		{
			
			//"yyyy-mm-dd"
			var s_date = this.f_get_value(e_input);
			
			var s_value_out = this.f_get_fe_s_value_as_db_date_string(s_date);
			
			return s_value_out ;
			
		},
		/*
			"yyyy-mm-dd"
		*/
		f_get_fe_s_value_as_db_date_string: function(s_date)
		{
			
			var s_value_out = s_date;
			
			return s_value_out ;
			
		},

		/*
			s_value_out -> "yyyy-mm-dd"
		*/
		f_get_value_as_fe_presentation_date_string: function(s_value)
		{
			let s_value_processed_ = s_value;

			//removing 'Z' at the end
			s_value_processed_ = (s_value_processed_!=null && s_value_processed_.length>0) ? 
										s_value_processed_.substr(0, s_value_processed_.length-1) :
										s_value_processed_;

			return s_value_processed_;
			
		},

		/*
			s_value_out -> "Oct 30, 2021"

			converts datetimes to dates

			2021-10-30T16:58:20+01:00 -> Oct 30, 2021
		*/
		f_get_value_as_fe_presentation_date_string_vers_02: function(s_value)
		{
			if(s_value == null || s_value == "") 
			{
				return "";
			}

			let s_value_processed_ = s_value;

			if( s_value_processed_!=null && s_value_processed_.length>0 )
			{
				//removing 'Z' at the end
				if( s_value_processed_.substr(s_value_processed_.length-1, 1) == 'Z' 
					|| s_value_processed_.substr(s_value_processed_.length-1, 1) == 'z'
				)
				{
					s_value_processed_ = s_value_processed_.substr(0, s_value_processed_.length-1);
				}
				// timestamps / datetimes:
				else if( s_value_processed_.indexOf('T') > -1
						|| s_value_processed_.indexOf('t')  > -1
				)
				{
					let i_pos_t = s_value_processed_.indexOf('T');
					if (i_pos_t == -1){
						i_pos_t = s_value_processed_.indexOf('t');
					}
					s_value_processed_ = s_value_processed_.substring( 0, i_pos_t )
				}
			}
			

			let s_date =  s_value_processed_;	//yyyy-mm-dd
			
			let b_date_is_valid = true;
			
			let a_dt = s_date.split("-");
			if (a_dt.length != 3){b_date_is_valid = false;}

			let s_year = a_dt[0];
			let s_month = a_dt[1];
			let s_day = a_dt[2];
			let i_day = parseInt(s_day);
			let i_month = parseInt(s_month);
			let i_year = parseInt(s_year);
			
			//new Date(year, month, day, hours, minutes, seconds, milliseconds) 

			// create the date object with the values sent in (month is zero based)
			let dt = new Date(i_year,i_month-1,i_day,0,0,0,0);

			let options = { year: 'numeric', month: 'short', day: 'numeric' };
			
			s_value_processed_ = dt.toLocaleDateString("en-US", options);
			//dt.toLocaleDateString("pt-PT", options);


			// 2010-04-08 -> 
			return s_value_processed_;
			
		},

		/*
			s_value_out -> "Oct 30, 2021"

			does nothing to datetimes

			2021-10-30T16:58:20+01:00 -> Oct 30, 2021
		*/
		f_get_value_as_fe_presentation_date_string_vers_03: function(s_value)
		{
			if(s_value == null || s_value == "") 
			{
				return "";
			}

			let s_value_processed_ = s_value;

			if( s_value_processed_!=null && s_value_processed_.length>0 )
			{
				//removing 'Z' at the end
				if( s_value_processed_.substr(s_value_processed_.length-1, 1) == 'Z' 
					|| s_value_processed_.substr(s_value_processed_.length-1, 1) == 'z'
				)
				{
					s_value_processed_ = s_value_processed_.substr(0, s_value_processed_.length-1);
				}
			}

			
			let s_date =  s_value_processed_;	//yyyy-mm-dd
			
			let b_date_is_valid = true;
			
			let a_dt = s_date.split("-");
			if (a_dt.length != 3){b_date_is_valid = false;}

			let s_year = a_dt[0];
			let s_month = a_dt[1];
			let s_day = a_dt[2];
			let i_day = parseInt(s_day);
			let i_month = parseInt(s_month);
			let i_year = parseInt(s_year);
			
			//new Date(year, month, day, hours, minutes, seconds, milliseconds) 

			// create the date object with the values sent in (month is zero based)
			let dt = new Date(i_year,i_month-1,i_day,0,0,0,0);

			let options = { year: 'numeric', month: 'short', day: 'numeric' };
			
			s_value_processed_ = dt.toLocaleDateString("en-US", options);
			//dt.toLocaleDateString("pt-PT", options);


			// 2010-04-08 -> 
			return s_value_processed_;
			
		},

		/*
		s_value 	-> "yyyy-mm-dd"
		s_value_out 	-> "yyyy-mm-dd"
		*/
		f_convert_from__db_format__to__update_format: function(s_value)
		{
			let s_value_out = s_value;
			return s_value_out;
		},
		
		f_add_left_zeros: function(i_required_digits_total_count, s)
		{
			var s_res = s;
			while(s_res.length<i_required_digits_total_count)
			{
				s_res = "0" + s_res;
			}
			return s_res;
		},
		
		f_date_is_valid: function(e_input)
		{
			var s_date =  this.f_get_value(e_input);//yyyy-mm-dd
			var o_validate = NSDateDatetimePrivate.o_validate;
			
			var b_date_is_valid = true;
			
			var a_dt = s_date.split("-");
			if (a_dt.length != 3){b_date_is_valid = false;}
			if(b_date_is_valid)
			{
				
				var s_year = a_dt[0];
				var s_month = a_dt[1];
				var s_day = a_dt[2];
				
				if (!o_validate.f_s_is_int(s_day)){b_date_is_valid = false;}
				if (!o_validate.f_s_is_int(s_month)){b_date_is_valid = false;}
				if (!o_validate.f_s_is_int(s_year)){b_date_is_valid = false;}
				if(b_date_is_valid)
				{
					var i_day = parseInt(s_day);
					var i_month = parseInt(s_month);
					var i_year = parseInt(s_year);
					
					//new Date(year, month, day, hours, minutes, seconds, milliseconds) 
					try { 

					  // create the date object with the values sent in (month is zero based)
					  var dt = new Date(i_year,i_month-1,i_day,0,0,0,0);

					  // get the month, day, and year from the object we just created 
					  var mon = dt.getMonth() + 1;
					  var day = dt.getDate();
					  var yr  = dt.getYear() + 1900;

					  // if they match then the date is valid
					  if ( mon == i_month && yr == i_year && day == i_day )
					  {
						b_date_is_valid = true;
					  }
					  else
					  {
						b_date_is_valid = false;
					  }
				   }
				   catch(e) {
					  b_date_is_valid = false;
				   }
				}
			}
			return b_date_is_valid;
			
			
		},
		
		//starting from 1
		f_translate_month_str_to_num: function(s_month){
				
				var a_str_months = ['Jan', 'Feb', 'Mar', 'Apr'
									, 'May', 'Jun', 'Jul', 'Aug'
									, 'Sep', 'Oct', 'Nov', 'Dec'];
									
				var i_pos = a_str_months.indexOf(s_month); 
				var i_month = i_pos + 1;
				return i_month;
			},
		//starting from 1
		f_translate_month_num_to_str: function(i_month){
				
				var a_str_months = ['Jan', 'Feb', 'Mar', 'Apr'
									, 'May', 'Jun', 'Jul', 'Aug'
									, 'Sep', 'Oct', 'Nov', 'Dec'];
									
				var i_pos = i_month-1;
				var s_month = a_str_months[i_pos];
									
				return s_month;
			},
		
		f_check_input_type_date_support: function()
		{
			NSFunctions.f_check_input_type_date_support();
		}
		
	},

	/*
	---------------------------------------------------------------------------------------------------------------------
	*/
	
	NSDatetime: {
		
	},
	
	o_validate : 
	{
		f_s_is_number: function (s)
		{
			var b_res = (isNaN(s) || s=="" )? false: true;
			return b_res;
		},
		
		f_s_is_int: function (s)
		{
			var b_res = (isNaN(s) || s.indexOf(".")>-1 || s=="" )? false: true;
			return b_res;
		},

		f_date_is_valid: function(s_date)
		{
			var b_date_is_valid = true;
			
			var a_dt = s_date.split("-");
			if (a_dt.length != 3){b_date_is_valid = false;}
			if(b_date_is_valid)
			{
				
				var s_year = a_dt[0];
				var s_month = a_dt[1];
				var s_day = a_dt[2];
				
				if (!this.f_s_is_int(s_day)){b_date_is_valid = false;}
				if (!this.f_s_is_int(s_month)){b_date_is_valid = false;}
				if (!this.f_s_is_int(s_year)){b_date_is_valid = false;}
				if(b_date_is_valid)
				{
					var i_day = parseInt(s_day);
					var i_month = parseInt(s_month);
					var i_year = parseInt(s_year);
					
					//new Date(year, month, day, hours, minutes, seconds, milliseconds) 
					try { 

					  // create the date object with the values sent in (month is zero based)
					  var dt = new Date(i_year,i_month-1,i_day,0,0,0,0);

					  // get the month, day, and year from the object we just created 
					  var mon = dt.getMonth() + 1;
					  var day = dt.getDate();
					  var yr  = dt.getYear() + 1900;

					  // if they match then the date is valid
					  if ( mon == i_month && yr == i_year && day == i_day )
					  {
						b_date_is_valid = true;
					  }
					  else
					  {
						b_date_is_valid = false;
					  }
				   }
				   catch(e) {
					  b_date_is_valid = false;
				   }
				}
			}
			return b_date_is_valid;
			
			
		}
	},
	
}